export interface Category {
  id: string;
  nameKey: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: "shoes",
    nameKey: "categoryShoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20sneakers%20and%20shoes%20collection%20displayed%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-shoes&orientation=landscape",
  },
  {
    id: "hoodies",
    nameKey: "categoryHoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20hoodies%20and%20sweaters%20folded%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-hoodies&orientation=landscape",
  },
  {
    id: "tshirts",
    nameKey: "categoryTShirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20t-shirts%20collection%20displayed%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-tshirts&orientation=landscape",
  },
  {
    id: "jackets",
    nameKey: "categoryJackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20jackets%20and%20outerwear%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-jackets&orientation=landscape",
  },
  {
    id: "pants",
    nameKey: "categoryPants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20pants%20and%20shorts%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-pants&orientation=landscape",
  },
  {
    id: "headwear",
    nameKey: "categoryHeadwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20caps%20and%20headwear%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-headwear&orientation=landscape",
  },
  {
    id: "sets",
    nameKey: "categorySets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20matching%20sets%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-sets&orientation=landscape",
  },
  {
    id: "underwear",
    nameKey: "categoryUnderwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20underwear%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-underwear&orientation=landscape",
  },
  {
    id: "jersey",
    nameKey: "categoryJersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20jerseys%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-jersey&orientation=landscape",
  },
  {
    id: "accessories",
    nameKey: "categoryAccessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20accessories%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-accessories&orientation=landscape",
  },
  {
    id: "bags",
    nameKey: "categoryBags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20bags%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-bags&orientation=landscape",
  },
  {
    id: "belts",
    nameKey: "categoryBelts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20belts%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-belts&orientation=landscape",
  },
  {
    id: "perfumes",
    nameKey: "categoryPerfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20perfume%20and%20fragrance%20bottles%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-perfumes&orientation=landscape",
  },
  {
    id: "other",
    nameKey: "categoryOther",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20miscellaneous%20items%20collection%20on%20warm%20neutral%20background%2C%20editorial%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20high-end%20fashion%20catalog%20aesthetic%20with%20warm%20earthy%20tones&width=600&height=400&seq=cat-other&orientation=landscape",
  },
];